const OPEN_GROUP_ACTION = "open-group";

const notificationTag = (groupId) => `group-${groupId}`;

const openGroupPath = (groupId) =>
  `/?action=${OPEN_GROUP_ACTION}&group=${encodeURIComponent(groupId)}`;

const OPEN_URL_MESSAGE = "split-it:open-url";

const SUBSCRIPTION_CHANGED_MESSAGE = "split-it:push-subscription-changed";

module.exports = {
  OPEN_GROUP_ACTION,
  notificationTag,
  openGroupPath,
  OPEN_URL_MESSAGE,
  SUBSCRIPTION_CHANGED_MESSAGE,
};
